/**
 * Check if HTML content is empty after stripping tags
 * Useful for rich text editors that may contain empty markup like "<p><br></p>"
 */
export function isHtmlEmpty(html: string): boolean {
  const stripped = html.replace(/<[^>]*>/g, "").trim()
  return stripped.length === 0
}

/**
 * Convert empty HTML to null, otherwise return the HTML
 * Prevents storing meaningless markup in the database
 */
export function emptyHtmlToNull(html: string): string | null {
  return isHtmlEmpty(html) ? null : html
}
